/* eslint-disable prettier/prettier */
import React from 'react';
import styles from '../../../styles/components/pageComponents/manageUsers/InviteUserForm.module.css';
import InputField from '../../controlVariations/InputField';
import Dropdown from '../../controlVariations/DropdownProgram';

// import Dropdown from "../../controlVariations/Dropdown";
// import MultiSelectDropdown from "../../controlVariations/MultiSelectDropdownProgram";

export interface InviteUserFormValues {
	fullName: string;
	email: string;
	phoneNumber: string;
	organizationName: string;
	// enrolledPrograms: string[];
	enrolledPrograms: string;
	platformRole: string;
}

export interface InviteUserFormErrors {
	fullName?: string;
	email?: string;
	phoneNumber?: string;
	organizationName?: string;
	enrolledPrograms?: string;
	platformRole?: string;
}

export interface InviteUserFormProps {
	title?: string;
	onClose?: () => void;
	values: InviteUserFormValues;
	errors?: InviteUserFormErrors;

	// programOptions: string[];
	programOptions: { label: string; value: string }[];
	// roleOptions: string[];
	roleOptions: { label: string; value: string }[];
	onChange: (field: keyof InviteUserFormValues, value: any) => void;
	onSubmit: () => void;

	loading?: boolean;
	disabled?: boolean;

	className?: string;
}

const InviteUserForm: React.FC<InviteUserFormProps> = ({
	title = 'Send Invite',
	onClose,

	values,
	errors = {},
	programOptions,
	roleOptions,
	onChange,
	onSubmit,
	loading = false,
	disabled = false,
	className,
}) => {
	return (
		<div className={`${styles.container} ${className || ''}`}>
			{/* HEADER */}
			<div className={styles.header}>
				<h2 className={styles.title}>{title}</h2>

				{onClose && (
					<button
						className={styles.closeButton}
						onClick={onClose}
						type="button"
					>
						✕
					</button>
				)}
			</div>

			{/* Mandatory fields label */}
			<p className={styles.mandatory}>
				<span className={styles.redAsterisk}>*</span> Mandatory Fields
			</p>

			{/* Row 1 */}
			<div className={styles.row}>
				<InputField
					label="Full name"
					required
					placeholder="John Doe"
					value={values.fullName}
					onChange={e => onChange('fullName', e.target.value)}
					error={!!errors.fullName}
					helperText={errors.fullName}
					disabled={disabled}
				/>

				<InputField
					label="Email id"
					required
					placeholder="john.doe@gmail.com"
					value={values.email}
					onChange={e => onChange('email', e.target.value)}
					error={!!errors.email}
					helperText={errors.email}
					disabled={disabled}
				/>
			</div>

			{/* Row 2 */}
			<div className={styles.row}>
				<InputField
					label="Phone Number"
					placeholder="+123 456 7890"
					value={values.phoneNumber}
					onChange={e => onChange('phoneNumber', e.target.value)}
					error={!!errors.phoneNumber}
					helperText={errors.phoneNumber}
					disabled={disabled}
				/>

				<InputField
					label="Organization Name"
					placeholder="Enter your Organization Name"
					value={values.organizationName}
					onChange={e => onChange('organizationName', e.target.value)}
					error={!!errors.organizationName}
					helperText={errors.organizationName}
					disabled={disabled}
				/>
			</div>

			{/* Row 3 */}
			<div className={styles.row}>
				<div className={styles.field}>
					<label className={styles.label}>
						Program<span className={styles.redAsterisk}>*</span>
					</label>

					<Dropdown
						placeholder="Select Program"
						options={programOptions.map(p => p.label)} // UI shows label
						selected={
							programOptions.find(
								p => p.value === values.enrolledPrograms
							)?.label || ''
						}
						onSelect={label => {
							const selectedProgram = programOptions.find(
								p => p.label === label
							);
							onChange(
								'enrolledPrograms',
								selectedProgram?.value || ''
							);
						}}
						width="100%"
						height={58}
						menuMaxHeight={240}
					/>

					{errors.enrolledPrograms && (
						<span className={styles.error}>
							{errors.enrolledPrograms}
						</span>
					)}
				</div>

				<div className={styles.field}>
					<label className={styles.label}>
						IOCM E2I Platform Role
						<span className={styles.redAsterisk}>*</span>
					</label>

					<Dropdown
						placeholder="Select Role"
						options={roleOptions.map(r => r.label)}
						selected={
							roleOptions.find(
								r => r.value === values.platformRole
							)?.label || ''
						}
						onSelect={label => {
							const selectedRole = roleOptions.find(
								r => r.label === label
							);
							onChange('platformRole', selectedRole?.value || '');
						}}
					/>

					{errors.platformRole && (
						<span className={styles.error}>
							{errors.platformRole}
						</span>
					)}
				</div>
			</div>

			{/* Submit Button */}
			<div className={styles.buttonRow}>
				<button
					className={styles.submitButton}
					onClick={onSubmit}
					disabled={disabled || loading}
				>
					{loading ? 'Sending...' : 'Send Invite'}
				</button>
			</div>
		</div>
	);
};

export default InviteUserForm;
